<script setup>
import { ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
const { locale } = useI18n();
let location = ref(locale.value);

let name;
let email;
let telf;
let company;
let howFindUs = '';
let selectedColor = ref('#757575');

function updateColor() {
    selectedColor.value = howFindUs === '' ? '#757575' : '#000';
}
let help;
let agreeCheck;
let agreeCheck2;
let xnQsjsdp = '6c1b28369d668c2c8cecc3b8c05c1b93f438d21da77cbc8f4a035432b5b39616'
let xmIwtLD = 'c92127d3c81dd385ec059caace30d10cdf6fe09907a2178e629f77e64991c56f'
let actionType = 'TGVhZHM='
const error = ref('')
const showError = ref(false)
const sendOkMsg = ref(false)
const showOk = ref(false)

watch(locale, () => {
    location = locale.value;
});


const validateEmail = (email) => {
    return String(email)
    .toLowerCase()
    .match(
        /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|.(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
    );
};

function checkForm() {
    error.value = ''
    showError.value = false
    showOk.value = false
    sendOkMsg.value = ''
    if(!name) {
        error.value = t('forms.required_name')
        showError.value = true
        return
    }
    if(!email) {
        error.value = t('forms.required_email')
        showError.value = true
        return
    }
    if(!validateEmail(email)) {
    error.value = t('forms.required_email_valid')
    showError.value = true
    setTimeout(() => {
        showError.value = false
        }, 5000)
        return
    }
    if(!company) {
        error.value = t('forms.required_company')
        showError.value = true
        return
    }
    if(!howFindUs || howFindUs === ''){
        error.value = t('forms.required_howFindUs')
        showError.value = true
        return
    }
    if(!agreeCheck) {
        error.value = t('custom_coookies.accept_policy')
        showError.value = true
        return
    }
    if (!agreeCheck2) {
        error.value = t('custom_coookies.accept_policy')
        showError.value = true
        setTimeout(() => {
            showError.value = false
        }, 5000)
        return
    }

    let formData = new FormData();
    formData.append('Email', email);
    formData.append('Company', company);
    formData.append('Phone', telf);
    formData.append('Mobile', telf);
    formData.append('First Name', name);
    formData.append('Last Name', name);
    formData.append('How Did You Find Us', howFindUs);
    formData.append('Lead Source', "Web CAR");
    formData.append('Lead Status', "No contactado");
    formData.append('returnURL', "https://www.inforserveis.es/");
    formData.append('LEADCF8', "-None-");
    formData.append('xnQsjsdp', xnQsjsdp);
    formData.append('xmIwtLD', xmIwtLD);
    formData.append('actionType', actionType);
    formData.append('zc_gad', '');

    const requestOptions = {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        mode: 'no-cors',
        body: formData
    };
    fetch("https://crm.zoho.eu/crm/WebToLeadForm", requestOptions)
        .then(() => {
            sendOkMsg.value = t('forms.ok_message');
            showOk.value = true;
            setTimeout(() => {
                showOk.value = false;
            }, 5000);
        });
}
</script>
<template>
    <div class="contact-body-wrapper">
        <div class="contact-title">
            <div class="contact-title-wrapper">
                {{ $t('contact.title') }}
            </div>
        </div>
        <div class="contact-body-container">
            <div class="contact-body-container-wrapper">
                <form @submit.prevent="checkForm">
                    <div class="contact-subtitle">
                        {{ $t('contact.subtitle_second') }}
                    </div>
                    <div class="contact-form">
                        <div class="contact-form-block">
                            <input class="contact-input" 
                                v-model="name"
                                :placeholder="t('contact.form_name')" />
                        </div>
                        <div class="contact-form-block">
                            <input class="contact-input"
                                v-model="email"
                                :placeholder="t('contact.form_email')" />
                        </div>
                        <div class="contact-form-block">
                            <input class="contact-input"
                                v-model="telf" 
                                :placeholder="t('contact.form_telf')" />
                        </div>
                        <div class="contact-form-block">
                            <input class="contact-input"
                                v-model="company"
                                :placeholder="t('contact.form_company')" />
                        </div>
                        <div class="contact-form-block">
                            <select 
                                class="contact-input contact-select"
                                v-model="howFindUs"
                                @change="updateColor"
                                :style="{ color: selectedColor }"
                            >
                                <option value="" disabled>
                                    {{ t('contact.how_did_you_find_us') }}
                                </option>
                                <option value="internet">{{ t('contact.car') }}</option>
                                <option value="friend">{{ t('contact.internet') }}</option>
                                <option value="advertisement">{{ t('contact.instagram') }}</option>
                                <option value="other">{{ t('contact.linkedin') }}</option>
                                <option value="other">{{ t('contact.recomendation') }}</option>
                                <option value="other">{{ t('contact.conventions') }}</option>
                                <option value="other">{{ t('contact.others') }}</option>
                            </select>
                        </div>
                        <div class="contact-form-block">
                            <textarea class="custom-text-area" rows="5"
                                v-model="help"
                                :placeholder="t('contact.form_textarea')" />
                        </div>
                    </div>
                    <div class="contact-form-extra-wrapper">
                        <div class="contact-form-more">
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                    <b>{{ $t('forms.header_bold') }}</b>
                                </div>
                            </div>
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                    <b>{{ $t('forms.text_1_bold') }}</b>
                                </div>
                            </div>
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                    <a href="mailto:dpd@inforserveis.es">
                                        <b>{{ $t('forms.text_2_bold') }}</b>
                                    </a>
                                </div>
                            </div>
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                <span class="contact-form-bold"><b>{{ $t('forms.text_3_bold') }}</b></span>
                                {{ $t('forms.text_3_1') }}
                                </div>
                            </div>
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                <span class="contact-form-bold"><b>{{ $t('forms.text_4_bold') }}</b></span>
                                {{ $t('forms.text_4_1') }}
                                </div>                    
                            </div>
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                <span class="contact-form-bold"><b>{{ $t('forms.text_5_bold') }}</b></span>
                                {{ $t('forms.text_5_1') }}
                                </div>
                            </div>
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                <span class="contact-form-bold"><b>{{ $t('forms.text_6_bold') }}</b></span>
                                <a class="mailto" href="mailto:contact@test.com">
                                    {{ $t('forms.text_6_1') }}
                                </a>
                            </div>
                            </div>
                            <div class="contact-form-requirements">
                                <div class="contact-form-requirements-title">
                                    <span class="contact-form-bold"><b>{{ $t('forms.text_7_bold') }}</b></span>
                                    <router-link :to="`/${location}/privacy`">
                                        {{ $t('forms.text_7_1') }}
                                    </router-link>
                                </div>
                            </div>
                            <div class="contact-agreement">
                                <label for="agreeCheck" class="custom-checkboxs">
                                    <input
                                        class="checkbox__input"
                                        type="checkbox"
                                        id="agreeCheck"
                                        v-model="agreeCheck"
                                    />
                                    <svg
                                        class="checkbox__icon"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 22 22"
                                    >
                                    <rect
                                        width="21"
                                        height="21"
                                        x=".5"
                                        y=".5"
                                        fill="#FFF"
                                        stroke="#000"
                                        rx="0"
                                    />
                                    <path
                                        class="tick"
                                        stroke="#0047ba"
                                        fill="none"
                                        stroke-linecap="round"
                                        stroke-width="4"
                                        d="M4 10l5 5 9-9"
                                    />
                                </svg>
                                <span class="checkbox__label">{{ $t('forms.text_8') }}</span>
                                </label>
                            </div>
                            <div class="contact-agreement">
                            <label for="agreeCheck2" class="custom-checkboxs">
                                <input
                                class="checkbox__input"
                                type="checkbox"
                                id="agreeCheck2"
                                v-model="agreeCheck2"
                                />
                                <svg
                                class="checkbox__icon"
                                xmlns="http://www.w3.org/2000/svg"
                                viewBox="0 0 22 22"
                                >
                                <rect
                                    width="21"
                                    height="21"
                                    x=".5"
                                    y=".5"
                                    fill="#FFF"
                                    stroke="#000"
                                    rx="0"
                                />
                                <path
                                    class="tick"
                                    stroke="#0047ba"
                                    fill="none"
                                    stroke-linecap="round"
                                    stroke-width="4"
                                    d="M4 10l5 5 9-9"
                                />
                                </svg>
                                <span class="checkbox__label">{{ $t('forms.text_9') }}
                                </span>
                            </label>
                            </div>
                        </div>
                    </div>
                    <div class="contact-error" v-if="showError">
                        <div class="contact-error-wrapper">
                            {{ error }}
                        </div>
                    </div>
                    <div class="contact-ok" v-if="showOk">
                        <div class="contact-error-wrapper">
                            {{ sendOkMsg }}
                        </div>
                    </div>
                    <div class="contact-send">
                        <button class="custom-btn" type="submit">
                            {{ $t('contact.submit') }}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>
<style lang="scss" scoped>
    @import "../../../styles/common.scss";
    .contact-body-wrapper {
        padding: 140px 12px; 
        .contact-title {
            font-size: 60px;
            letter-spacing: -3px;
            font-family: 'CircularStd-Black';
            padding-bottom: 30px;
            display: flex;
            justify-content: center;
            width: 100%;
            .contact-title-wrapper {
                text-align: left;
                width: 815px;
            }
        }
        .contact-body-container {
            width: 100%;
            display: flex;
            justify-content: center;
            .contact-body-container-wrapper {
                width: 815px;
                text-align: left;
                .contact-subtitle {
                    font-size: 30px;
                    font-family: 'CircularStd-Book';
                    padding-bottom: 43px;
                }
                .contact-form-block {
                    padding-bottom: 25px;
                    .contact-input {
                        width: 95%;
                    }
                    .custom-text-area {
                        width: 95%;
                    }
                }
                .contact-form-more, .contact-send {
                    max-width: 770px;
                    margin: 0 auto;
                    .contact-agreement {
                        .checkbox__label {
                            letter-spacing: -0.8px;
                            font-family: 'CircularStd-Book';
                        }
                    }
                    .contact-extra {
                        font-size: 12px;
                        letter-spacing: -0.6px;
                        font-family: 'CircularStd-Book';
                        padding-top: 23px;
                    }
                }
                .contact-form-extra-wrapper {
                    max-width: 100%;
                    font-size: 12px;
                    .contact-form-more {
                        max-width: 100%;
                    }
                    a {
                        text-decoration: none;
                        color: #696969;
                    }
                }
                .contact-send {
                    padding-top: 64px;
                    display: flex;
                    justify-content: end;
                }
            }
            .contact-error {
                padding-top: 1rem;
                .contact-error-wrapper {
                    background-color: rgba(251, 206, 199);
                    color: rgba(210, 35, 8);
                    padding: 1rem;
                    border-radius: 16px;
                    text-align: center;
                }
            }
            .contact-ok {
                padding-top: 1rem;
                .contact-error-wrapper {
                    background-color: rgba(224, 245, 217);
                    color: rgb(98, 136, 87);
                    padding: 1rem;
                    border-radius: 16px;
                    text-align: center;
                }
            }
        }
        .contact-form-requirements {
            color: #696969;
            a {
                color: #696969;  
            }
        }

        select.contact-input.contact-select {
            height: 63px;
            appearance: none; 
            background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='%239e9e9e'%3E%3Cpath d='M7 10l5 5 5-5H7z'/%3E%3C/svg%3E"); /* SVG de la flecha */
            background-repeat: no-repeat;
            background-position: right 10px center; 
            background-size: 20px; 
            cursor: pointer;
        }
        
    }
    @media (max-width: 600px) {
        .contact-body-wrapper {
            padding-top: 50px;
            .contact-title {
                font-size: 35px;
            }
            .contact-body-container .contact-body-container-wrapper .contact-subtitle {
                font-size: 20px;
            }
        }
        .contact-body-wrapper .contact-body-container .contact-body-container-wrapper .contact-form-block  {
            padding-bottom: 10px;
        }
    }
</style>